import React, { Component } from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import '../assets/css/App.css';
import GradeCal from './GradeCal';

class App extends Component {
  render() {
    return (
      <Container>
        <Row className="justify-content-md-center">
          <Col md={{ span: 8, offset: 2 }} xs={{ span: 10, offset: 1 }} className='card'>
            <h3>Grade-Calculator</h3>
            <hr/>
            <GradeCal/>
            <hr/>
            <h4>Thanks.</h4>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default App;
